import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white border-t border-dark-grey">
      <div className="max-w-8xl mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="/syncore-logo.png" 
              alt="SYNCORE LLC" 
              className="h-8 w-auto mb-4"
            />
            <p className="text-mid-grey text-sm leading-relaxed">
              A digital agency delivering innovative solutions in web development, blockchain, and creative technology.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-mono text-xs uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-mono text-xs uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/web-development" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  Web Development
                </Link>
              </li>
              <li>
                <Link to="/services/ui-ux-design" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  UI/UX Design
                </Link>
              </li>
              <li>
                <Link to="/services/blockchain" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  Blockchain
                </Link>
              </li>
              <li>
                <Link to="/services/mobile-app" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  Mobile Apps
                </Link>
              </li>
              <li>
                <Link to="/services/cloud-solutions" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  Cloud Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-mono text-xs uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Mail size={16} className="text-light-pink mt-1" />
                <a href="mailto:info@syncorellc.com" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                  info@syncorellc.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="text-light-pink mt-1" />
                <span className="text-mid-grey text-sm">
                  530 Technology Dr., Suite 100 & 200, Irvine, California, 92618, USA
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-dark-grey">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-mid-grey text-sm">
              © 2026 SYNCORE LLC. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms-conditions" className="text-mid-grey hover:text-light-pink transition-colors text-sm">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
